import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import { DAYS } from '../../../constants';
import { isToday } from '../../../utils';

const HeaderCell = ({ date }) => {
  const dayName = DAYS[date.getDay()];
  const dayNumber = date.getDate();
  const isActive = isToday(date);

  const cellStyles = cn(
    'flex flex-col items-center gap-0.5 p-2 border-l',
    isActive && 'text-primary'
  );

  const dayNameStyles = cn(
    'text-[11px] font-semibold uppercase tracking-wide',
    isActive ? 'text-primary' : 'text-muted-foreground'
  );

  const dayNumberStyles = cn(
    'flex items-center justify-center size-6 text-sm font-semibold rounded-full',
    isActive && 'bg-primary text-primary-foreground'
  );

  return (
    <div className={cellStyles}>
      <div className={dayNameStyles}>{dayName}</div>
      <div className={dayNumberStyles}>{dayNumber}</div>
    </div>
  );
};

HeaderCell.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

export default HeaderCell;
